import { type GetMetricGroupsQueryParams } from '@gonfalon/openapi/operations/getMetricGroups';

import { createInfiniteQueryHook } from '../internal/createInfiniteQueryHook';
import { reactQueryResponseAdapter } from '../internal/reactQueryResponseAdapter';

export const useInfiniteMetricGroups = createInfiniteQueryHook(
  ({ projectKey, params }: { projectKey: string; params?: GetMetricGroupsQueryParams }) => ({
    queryKey: ['infinite-metric-groups', projectKey, params],
    queryFn: async ({ pageParam }) => {
      const { getMetricGroups } = await import('@gonfalon/openapi/operations/getMetricGroups');
      return reactQueryResponseAdapter(
        getMetricGroups({
          projectKey,
          query: { ...params, ...pageParam },
        }),
      );
    },
    initialPageParam: {
      offset: params?.offset ?? 0,
      limit: params?.limit ?? 15,
    } as GetMetricGroupsQueryParams,
    getNextPageParam: (lastPage, allPages) => {
      const limit = params?.limit ?? 15;
      const totalCount = lastPage.totalCount ?? 0;
      const currentOffset = allPages.length * limit;

      if (currentOffset >= totalCount) {
        return undefined;
      }

      return {
        offset: currentOffset,
        limit,
      } as GetMetricGroupsQueryParams;
    },
  }),
);
